import React from 'react';
import { Box, Typography } from '@mui/material';
import { dashboardTokens as t } from './tokens';

export default function SectionHeader({ title, subtitle, action }) {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            mb: subtitle ? 2.5 : 2,
        }}>
            <Box sx={{ minWidth: 0 }}>
                <Typography component="h3" sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: t.color.fg,
                    lineHeight: 1.3,
                }}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography sx={{
                        fontSize: 13,
                        color: t.color.fgMuted,
                        mt: 0.5,
                    }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
        </Box>
    );
}
